
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Badge, IconButton, MenuItem } from '@mui/material';
import { connect } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Menu from '@mui/material/Menu';
import React from 'react';
import { logout } from '../../../utils';
import push_notifications from '../../../push_notifications';
import NotificationsIcon from '@mui/icons-material/Notifications';
import request from '../../../request';
import { NOTIFICATION_TYPE } from '../../../../../shared/constants';
import links from '../../../links';
import logger from '../../../logger';
import Image from '../../../components/Image';


function Notifications({ notifications, onClick }) {

	if (!notifications.length)
		return <div className='flex items-center justify-center text-gray-500 text-sm h-[300px] aspect-square'>No notifications</div>;

	return <div className='max-w-[400px] max-h-[600px] overflow-y-auto'>
		{
			notifications.map(n => <div
					key={n._id}
					className={`p-4 [&:not(:last-child)]:border-b border-gray-200 ${n.read ? 'bg-white' : 'bg-gray-100'} cursor-pointer`}
					onClick={() => onClick && onClick(n)}
				>
				<div className='text-sm font-bold truncate'>{n.title}</div>
				<div className='text-xs truncate'>{n.body}</div>
			</div>)
		}
	</div>;

}

class UserThumbnailUnconnected extends React.Component {
	
	state = {
		logoutAnchorEl: null,
		notificationsAnchorEl: null,
		notifications: [],
	}

	handleMenuOpen = (event) => {
		this.setState({ logoutAnchorEl: event.currentTarget });
	}

	handleMenuClose = () => {
		this.setState({ logoutAnchorEl: null });
	}

	handleLogout = () => {
		this.setState({ logoutAnchorEl: null });
		logout();
	}

	handleNotificationsOpen = (event) => {
		this.setState({ notificationsAnchorEl: event.currentTarget });
	}

	handleNotificationClick = async (notification) => {

		// close the notifications menu
		this.setState({ notificationsAnchorEl: null });

		// navigate
		let path;
		const { data } = notification;

		switch (notification.type) {
			case NOTIFICATION_TYPE.LOAN:
				path = links.loan(data._id);
				break;
			case NOTIFICATION_TYPE.CASH_REQUISITION:
				path = links.cashRequisition(data._id);
				break;
			case NOTIFICATION_TYPE.DELIVERY:
				path = links.delivery(data._id);
				break;
			case NOTIFICATION_TYPE.INSTALLATION:
				path = links.installation(data._id);
				break;

			case NOTIFICATION_TYPE.TOKEN:
				path = links.token();
				break;
		
			default:
				const error = new Error(`Unknown notification type: ${notification.type}`);
				logger.error(error);
		}

		if (path)
			window.App.redirect(path);

		// mark notification as read
		try {
			const res = await request.post(`/api/general/notifications/${notification._id}/read`);
			const notifications = this.state.notifications.map(n => n._id === notification._id ? res.data : n);
			this.setState({ notifications });
		} catch (e) {
			console.error(e);
		}

	}

	componentWillUnmount() {
		push_notifications.unsubscribe();
	}

	componentDidMount() {

		push_notifications.subscribe();

		push_notifications.on("notifications", newNotifications => {
			const notifications = [ ...newNotifications, ...this.state.notifications ];
			this.setState({ notifications });

			// play a sound if any of the notifications are unread
			if (newNotifications.some(n => !n.read))
				push_notifications.beep();
			
		});
	}

	render() {

		const { name, surname, roles, profile_picture } = this.props;
		const { logoutAnchorEl } = this.state;

		const unReadNotificationsCount = this.state.notifications.filter(n => !n.read).length;

		let profilePicture;
		if (profile_picture) {
			profilePicture = <div className='w-[40px] aspect-square rounded-full overflow-hidden border'>
				<Image
					src={profile_picture}
					aspectRatio={1}
				/>
			</div>
		} else {
			profilePicture = <div className='flex items-center text-4xl text-gray-400'>
				<AccountCircleIcon fontSize='inherit' />
			</div>
		}

		return (
			<>
				<div className="grid grid-cols-[auto,auto,1fr,auto] gap-1">
					<div className='flex items-center border-r pr-2 mr-2'>
						<Badge
							badgeContent={unReadNotificationsCount}
							color="error"
							overlap="circular" max={9}
						>
							<IconButton onClick={this.handleNotificationsOpen}>
								<NotificationsIcon />
							</IconButton>
						</Badge>
					</div>
					{profilePicture}
					<div className='flex items-center'>
						<div className="text-gray-600 capitalize">
							<div className="font-bold text-sm">
								{name} {surname}
							</div>
							<div className='text-xs'>
								{roles[0].toUpperCase().replace(/[-_]/g, ' ')} {
									roles?.length > 1 && <span className='inline-flex text-[8px] font-bold items-center justify-center aspect-square bg-orange-600 text-white px-1 rounded-full'>
										+{roles.length - 1}
									</span>
								}
							</div>
						</div>
					</div>
					<div className='flex items-center'>
						<IconButton
							aria-controls="simple-menu"
							aria-haspopup="true"
							onClick={this.handleMenuOpen}
						>
							<ExpandMoreIcon />
						</IconButton>
					</div>
				</div>
				{
					this.state.logoutAnchorEl && <Menu
						id="simple-menu"
						anchorEl={logoutAnchorEl}
						open
						onClose={this.handleMenuClose}
					>
						<MenuItem onClick={this.handleLogout}>
							Logout
						</MenuItem>
					</Menu>
				}
				{
					this.state.notificationsAnchorEl && <Menu
						open
						anchorEl={this.state.notificationsAnchorEl}
						onClose={() => this.setState({ notificationsAnchorEl: null })}
					>
						<Notifications notifications={this.state.notifications} onClick={this.handleNotificationClick} />
					</Menu>
				}
			</>
		);
	}
}


const mapStateToProps = state => {
	const { name, surname, roles, profile_picture } = state.user || {}
	return { name, surname, roles, profile_picture }
}

const UserThumbnail = connect(mapStateToProps)(UserThumbnailUnconnected);
export default UserThumbnail;